import { defaultApi } from '@/api';
import { useMutation } from 'react-query';

const useSamlLogin = () => {
  return useMutation<{ data: { url: string } }>(async () => {
    return defaultApi.post('/saml2/login');
  });
};

export default useSamlLogin;
